<div class="spinner" [class.override-margins]="overrideMargins">
  <zaver-loading-dots [color]="'#b7bcc8'"></zaver-loading-dots>
  <p class="info-text">
    {{ infoText }}
  </p>
</div>
